import api from "@/lib/api";

const seen = new Set();

/** Fire-and-forget upgrade-funnel event. preview_open is deduped per feature per page session. */
export function trackUpgrade(kind, feature, source) {
  const key = `${kind}:${feature || ""}:${source || ""}`;
  if (kind === "preview_open") { if (seen.has(key)) return; seen.add(key); }
  api.post("/upgrade-events", { kind, feature: feature || null, source: source || null, path: window.location.pathname }).catch(() => {});
}

/** Append ?src= so the preview page can attribute the open to the nudge that sent the trainer there. */
export const withSrc = (to, source) => `${to}${to.includes("?") ? "&" : "?"}src=${encodeURIComponent(source)}`;
